import { AxiosResponse } from "axios";
import { toast } from "react-hot-toast";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  deleteCompanyRecordFailure,
  deleteCompanyRecordSuccess,
} from "../slices/features/company";
import { RequestTypes } from "../types";

const companyService = new AppService();

function* deleteCompany(action: any) {
  const { payload } = action;

  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      companyService.deleteCompaniesData,
      baseUrl,
      action.payload.id,
      action.payload.deletionReason
        ? {
            deletionReason: action.payload.deletionReason,
            deletionReasonNote: action.payload.deletionReasonNote,
          }
        : undefined
    );

    toast.success(response?.data?.message);

    payload?.cbSuccess && payload?.cbSuccess();

    yield put(deleteCompanyRecordSuccess({ ...response }));
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const {
      data: {
        errors: { message },
      },
    } = error;

    toast.error(Array.isArray(message) ? message[0] : message);

    yield put(deleteCompanyRecordFailure({ statusCode, statusText }));
  }
}

export function* watchDeleteComapny() {
  yield takeLatest(RequestTypes.DELETE_COMPANY_RECORD, deleteCompany);
}
